import "./index.css";
import { clsx } from "clsx";
import { useCallback, useId } from "react";
import { useControlledValue } from "../../hooks/useControlledValue";
import type { ICollapsibleProps } from "./types";

export const Collapsible = ({
  trigger,
  content,
  defaultOpen,
  open,
  onOpenChange,
  disabled = false,
}: ICollapsibleProps) => {
  const { value: isOpen, onChange: setIsOpen } = useControlledValue<boolean>({
    controlledValue: open,
    controlledOnChange: onOpenChange,
    defaultValue: defaultOpen ?? false,
  });

  const triggerId = useId();
  const contentId = useId();

  const handleToggle = useCallback(() => {
    if (disabled) return;
    setIsOpen((prev) => !prev);
  }, [disabled, setIsOpen]);

  const triggerElement = trigger({
    toggle: handleToggle,
    isOpen: !!isOpen,
    triggerId,
    contentId,
    disabled,
  });

  return (
    <div className="nuco-collapsible">
      {triggerElement}
      <div
        className={clsx(
          "nuco-collapsible__content-wrapper",
          isOpen && "nuco-collapsible__content-wrapper--expanded",
        )}
        id={contentId}
        role="region"
        aria-labelledby={triggerId}
        aria-hidden={!isOpen}
        data-state={isOpen ? "open" : "closed"}
      >
        <div className="nuco-collapsible__content">{content}</div>
      </div>
    </div>
  );
};
